import { useState } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { usePlatform } from '@/features/users';

const FixedBudget = () => {
  const platform = usePlatform();
  const isDV360 = platform === 'DV360';

  const [budget, setBudget] = useState(30000);
  const [cpm, setCpm] = useState(2.5);
  const impressions = Math.round((budget / cpm) * 1000);
  const formattedImpressions =
    impressions === Infinity || isNaN(impressions) ? 0 : impressions;

  return (
    <>
      <Box p={3} pt={1.5}>
        <Stack
          direction='row'
          gap={2}
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography>
            {isDV360 ? 'Insertion Order Budget' : 'Campaign Budget'}
          </Typography>
          <TextField
            size='small'
            type='number'
            value={budget}
            onChange={(event) => {
              const newBudget = Number(event.target.value);
              if (newBudget >= 0) {
                setBudget(newBudget);
              }
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <Typography variant='body16' pr={1} color='text.secondary'>
                    $
                  </Typography>
                ),
              },
              htmlInput: {
                'aria-label': 'Budget',
                min: 0,
                step: 100,
              },
            }}
            sx={{ width: 200 }}
          />
        </Stack>

        <Stack
          direction='row'
          gap={2}
          alignItems='center'
          justifyContent='space-between'
          pt={3.5}
        >
          <Typography>CPM</Typography>
          <TextField
            size='small'
            type='number'
            value={cpm}
            onChange={(event) => {
              const newCpm = Number(event.target.value);
              if (newCpm >= 0 && newCpm <= 10) {
                setCpm(newCpm);
              }
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <Typography variant='body16' pr={1} color='text.secondary'>
                    $
                  </Typography>
                ),
              },
              htmlInput: {
                'aria-label': 'CPM',
                min: 0,
                max: 10,
                step: 0.01,
              },
            }}
            sx={{ width: 200 }}
          />
        </Stack>
        <Box py={1}>
          <Slider
            aria-label='CPM'
            value={cpm}
            onChange={(_event, newValue) => {
              setCpm(newValue);
            }}
            step={0.01}
            min={0}
            max={10}
            valueLabelDisplay='auto'
          />
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='body14' color='text.secondary'>
              0
            </Typography>
            <Typography variant='body14' color='text.secondary'>
              $10
            </Typography>
          </Stack>
        </Box>
      </Box>

      <Divider />

      <Box p={3}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <Box>
            <Typography variant='body2'>Expected Impressions</Typography>
          </Box>

          <Typography
            variant='body1'
            fontWeight={600}
            data-testid='expected-impressions'
          >
            {new Intl.NumberFormat('en-US', {
              style: 'decimal',
              maximumFractionDigits: 0,
            }).format(formattedImpressions)}
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default FixedBudget;
